<template>
  <transition name="animation-fade">
    <div
      v-if="show"
      class="pwa-message"
      :class="{'pwa-message--touch': touch}"
      @click="close()"
      @touchstart="touch = true"
      @touchend="touch = false">
      <img class="pwa-message__icon" src="/choice/img/pwa/icon-512.png" alt="">
      <div class="pwa-message__body">
        ホーム画面に追加すると<br>使いやすくなります。
      </div>
      <div class="pwa-message__close">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </transition>
</template>



<script>
export default {
  data() {
    return {
      show: false,
      touch: false,
    }
  },
  created() {
    this.decision()
  },
  methods: {
    decision() {
      if (
        navigator.userAgent.indexOf('iPhone') > 0 ||
        navigator.userAgent.indexOf('iPod') > 0 ||
        navigator.userAgent.indexOf('iPad') > 0 ||
        navigator.userAgent.indexOf('Android') > 0
      ) {
        if (
          !window.matchMedia('(display-mode: fullscreen)').matches &&
          !localStorage.getItem('pwa-message')
        ) {
          this.show = true
        }
      }
    },
    close() {
      localStorage.setItem('pwa-message', true)
      this.show = false
    },
  }
}
</script>



<style lang="scss">
.pwa-message {
  display: flex;
  align-items: center;
  position: fixed;
  left: 50%;
  bottom: 20px;
  z-index: map-get($z-index, pwa-message);
  transform: translateX(-50%);
  transition: $transition;
  box-shadow: 0 10px 20px rgba(#000, 0.12), 0 6px 6px rgba(#000, 0.15);
  border-radius: 20px;
  background-color: #fff;
  width: 296px;
  padding: 16px 24px 16px 16px;
  &--touch {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.10), 0 3px 6px rgba(0, 0, 0, 0.15);
  }

  &__icon {
    display: block;
    border-radius: 16px;
    border: 1px solid $oc-gray-2;
    width: 64px;
    height: 64px;
    margin-right: 16px;
  }

  &__body {
    font-size: 15px;
    line-height: 1.5;
  }
  &__close {
    position: absolute;
    right: 14px;
    top: 10px;
    z-index: 1;
    color: $oc-gray-5;
  }
}
</style>
